import BossModel from "@/models/BossModel";
import MarginVersion from '@/models/Margin/MarginVersion/MarginVersion'

export default class Margin extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'margin';

    /**
     *
     * @type {string}
     */
    static entity = 'margins';

    static fields() {
		return {
			id: this.number(null).nullable(),
			active_version_id: this.number(null).nullable(),
			concept_version_id: this.number(null).nullable(),
            active_version: this.belongsTo(MarginVersion, 'active_version_id'),
            concept_version: this.belongsTo(MarginVersion, 'concept_version_id'),
		}
	}

    /**
     *
     * @returns {*}
     */
    static loadAll() {
        return this.api()
            .limit(0)
            .where('is_active', true)
            .get();
    }

    /**
     * find or create concept
     * @returns {*}
     */
    fetchConcept() {
        return this.constructor.api().action(this.id + '/concept').getSingle();
    }

    /**
     *
     * @returns {boolean|*}
     */
    ActiveVersion(){
        return this.getRelated('active_version');
    }

    /**
     *
     * @returns {boolean|*}
     */
    ConceptVersion(){
        return this.getRelated('concept_version');
    }
}
